import React, { FC, useContext, useCallback } from "react";

import AccordionItem, {
  IAccordionItemProps,
} from "../../ActionsSelectors/Accordion/AccordionItem";
import { OptionSelectorContext } from "./OptionSelector";

const OptionItem: FC<IAccordionItemProps> = ({ id, children }) => {
  const context = useContext(OptionSelectorContext);

  const handleToggle = useCallback(
    (item: string, isExpanded: boolean) => {
      isExpanded && context?.onChange && context.onChange(item);
    },
    [context],
  );

  return (
    <AccordionItem
      onToggle={handleToggle}
      id={id}
      radioButtonAccordion
      isExpanded={context?.selectedItem === id}
      classes={{
        root: "optselector-item",
        toggled: context?.selectedItem === id && "active",
      }}
    >
      {children}
    </AccordionItem>
  );
};

export default OptionItem;
